export default "__VITE_ASSET__BtaCjHi9__"